import { z } from 'zod';

export const LawFirmSchema = z.object({
  client: z.string(),
  clientDomain: z.string().nullable(),
});

export type LawFirm = z.infer<typeof LawFirmSchema>;
